import { FilterValue } from "../Filters/FilterValue";
import { InvoiceFilters } from "../Invoice/InvoiceFilters";
import { SortType } from "../SortType";

export interface VoucherFilters {
  page_no: number;
  search_text?: string;
  limit: number;
  order_id?: FilterValue[] | null;
  customer_id?: FilterValue[] | null;
  sort_by: string;
  sort_type: SortType;
}

export interface VoucherAPIFilters {
  page_no: number;
  search_text?: string;
  order_id?: string[] | null;
  customer_id?: string[] | null;
  limit: number;
  sort_by: string;
  sort_type: SortType;
}

export function parseQueryParamsForVoucherFilters(
  params: VoucherFilters | null,
  query_params: URLSearchParams
): VoucherFilters {
  return {
    page_no: query_params.get("page_no")
      ? parseInt(query_params.get("page_no")!)
      : params?.page_no ?? 1,
    search_text: query_params.get("search_text") ?? params?.search_text ?? "",
    limit: query_params.get("limit")
      ? parseInt(query_params.get("limit")!)
      : params?.limit ?? 30,
    sort_by: query_params.get("sort_by") ?? params?.sort_by ?? "id",
    sort_type: query_params.get("sort_type")
      ? (query_params.get("sort_type") as SortType)
      : params?.sort_type ?? SortType.DESC,
    order_id: query_params.get("order_id")
      ? query_params
          .get("order_id")
          ?.split(",")
          .map((item) => ({
            id: item,
            value: item,
          }))
      : params?.order_id ?? [],
    customer_id: query_params.get("customer_id")
      ? query_params
          .get("customer_id")
          ?.split(",")
          .map((item) => ({
            id: item,
            value: item,
          }))
      : params?.customer_id ?? [],
  };
}
